import { useCallback } from 'react';
import { getUrl } from '@utils';
import { useRouter } from 'next/router';

export const useDataGridModel = ({ url, page, pageSize, defaultPageSize }) => {
  const router = useRouter();
  // Use provided url or fall back to current pathname
  const targetUrl = url || router.pathname;

  const handlePageChange = useCallback(
    (newPage, newPageSize) => {
      const currentPage = router.query.page || '1';
      const currentPageSize = router.query.pageSize || pageSize.toString();

      const urlParams = { ...router.query };

      if (newPage !== currentPage) {
        urlParams.page = newPage;
      }

      if (newPageSize && newPageSize.toString() !== currentPageSize) {
        urlParams.pageSize = newPageSize;
        urlParams.page = 1;
      }

      router.push(getUrl(urlParams, targetUrl));
    },
    [router, targetUrl, pageSize]
  );

  const handlePaginationModelChange = useCallback(
    (newPaginationModel) => {
      const { page: newPage, pageSize: newPageSize } = newPaginationModel;

      if (newPage !== page - 1) {
        handlePageChange(Number(newPage) + 1, pageSize || defaultPageSize);
      }

      if (newPageSize !== (pageSize || defaultPageSize)) {
        handlePageChange(1, newPageSize);
      }
    },
    [page, pageSize, handlePageChange, defaultPageSize]
  );

  const handleSortModelChange = useCallback(
    (sortModel) => {
      router.push(
        getUrl(
          {
            ...router.query,
            orderBy: sortModel?.[0]?.field || '',
            order: sortModel?.[0]?.sort || '',
          },
          targetUrl
        )
      );
    },
    [targetUrl, router]
  );

  return {
    handlePageChange,
    handlePaginationModelChange,
    handleSortModelChange,
  };
};
